import * as React from 'react';
import styled from 'styled-components';

import { fromScreen } from '@doltech/core/lib/responsive/responsive.util';
import { IconSystemV2EssentialClose } from '@doltech/icons/SystemV2/IconSystemV2EssentialClose';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { shadows } from '@doltech/ui/lib/figma/shadows';
import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';
import { ButtonIconSecondary } from '@doltech/ui/lib/figma/Button/ButtonIconSecondary/ButtonIconSecondary';

const CloseAction = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
`;

const HeadingList = styled.div``;

const Container = styled.div`
  padding: 12px 16px 20px;
  background-color: ${colorsV2.white100};
  border-top: 1px solid ${colorsV2.neutral40};
  border-right: 1px solid ${colorsV2.neutral40};
  border-left: 1px solid ${colorsV2.neutral40};
  border-radius: 16px 16px 0 0;
  box-shadow: 0px -16px 24px 0px ${colorsV2.blackShadow6};

  ${fromScreen(451)} {
    padding: 12px 20px 16px;
    border: 1px solid ${colorsV2.neutral40};
    border-radius: 16px;
    box-shadow: ${shadows.neutralShadowToBot4};
  }
`;

interface LandingSideInfoTableOfContentPopoverProps {
  title?: string;
  content?: {
    id?: string;
    render?: () => React.ReactNode;
  }[];
  onClose?: () => void;
}

export const LandingSideInfoTableOfContentPopover = (props: LandingSideInfoTableOfContentPopoverProps) => {
  const { title, content, onClose } = props;

  return (
    <Container className="landing-side-info-table-of-content-popover">
      <ResponsiveTypography.Paragraph variant="semi-bold/16-24" color="neutral180" mb="12px">
        {title}
      </ResponsiveTypography.Paragraph>
      <HeadingList>
        {content?.map((singleContent) => {
          const { id, render } = singleContent;
          return <React.Fragment key={id}>{render?.()}</React.Fragment>;
        })}
      </HeadingList>
      <CloseAction>
        <ButtonIconSecondary
          buttonStyle="gray1"
          size="medium"
          icon={<IconSystemV2EssentialClose />}
          onClick={onClose}
          transparent
        />
      </CloseAction>
    </Container>
  );
};
